import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=b645fb1c&scoped=true&"
import script from "./UsersView.vue?vue&type=script&lang=js&"
export * from "./UsersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b645fb1c",
  null
  
)

export default component.exports